import cookie from 'js-cookie';

import { WEBSITE_TOKEN_COOKIE } from '@farmersdog/constants';

export function getTokenFromCookie() {
  return cookie.get(WEBSITE_TOKEN_COOKIE);
}
